import React from 'react';
import { connect } from 'react-redux';
import { timeFormat as format } from 'd3';
import { timeMinute } from 'd3-time';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import listPortfolios from '../actions/query-api/list-portfolios';
import deletePortfolio from '../actions/query-api/delete-portfolio';
import favoritePortfolio from '../actions/query-api/favorite-portfolio';

import ImportantInfoModal from '../components/ImportantInfoModal/ImportantInfoModal.js';

import loadingIndicator from '../assets/local-loading.gif';
import Favorite from './Favorite';

import './style.css';

const mapStateToProps = state => ({
  history: state.history,
  pendingDeletePortfolio: state.pendingDeletePortfolio,
  pendingFavoritePortfolio: state.pendingFavoritePortfolio,
  investmentGoalOptions: state.investmentGoalOptions,
  modelPortfolios: state.entry.modelPortfolios,
  TEXT: state.complianceText,
  inFocus: state.entry.inFocus,
  featuresEditPortfolioName: state.features.editPortfolioName,
  importantInfoAccepted: state.importantInfoAccepted,
  dpdIsOpen: state.dpdIsOpen,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  listPortfolios: () => dispatch(listPortfolios),
  loadPortfolio: portfolio => dispatch({ type: 'LOAD_PORTFOLIO', portfolio }),
  deleteSavedPortfolio: id => dispatch(deletePortfolio(id)),
  favoriteSavedPortfolio: (id, value) => dispatch(favoritePortfolio(id, value)),
  setSelectedModel: (model, side) => dispatch({ type: 'SET_SELECTED_MODEL', model, side: side }),
  setCompareMode: (side) => dispatch({ type: 'SET_COMPARE_MODE_SAVED_MODEL_PORTFOLIO', side: side}),
  setSelectedModelFamily: (modelFamily, side) => dispatch({ type: 'SET_SELECTED_MODEL_FAMILY', modelFamily, side: side }),
  setShowModelInput: (show, side) => dispatch({ type: 'SET_SHOW_MODEL_INPUT', show, side: side }),
  setImportantInfoAccepted: () => dispatch({ type: 'SET_IMPORTANT_INFO_ACCEPTED'}),
});

class History extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      currPage: 0,
      numPerPage: 5,
    };

    this.paginate = this.paginate.bind(this);
    this.handleCloseImportantInfoModal = this.handleCloseImportantInfoModal.bind(this);
  }
  componentDidMount() {
    this.props.listPortfolios();
  }

  handleCloseImportantInfoModal() {

    this.props.setImportantInfoAccepted();

  }

  paginate({ selected }) {
    this.setState(Object.assign({}, this.state, {
        currPage: selected,
    }));
  }

  render() {
    const {
      history,
      pendingDeletePortfolio,
      pendingFavoritePortfolio,
      width,
      investmentGoalOptions,
      TEXT,
      inFocus,
      featuresEditPortfolioName,
      importantInfoAccepted,
      dpdIsOpen,
    } = this.props;
    const {
      deleteSavedPortfolio,
      favoriteSavedPortfolio,
      loadPortfolio,
      setSelectedModel,
      setCompareMode,
      setSelectedModelFamily,
      setShowModelInput,
    } = this.props;

    const {
      currPage,
      numPerPage,
    } = this.state;

    const min = currPage * numPerPage;
    const max = min + numPerPage;

    const formatDate = width < 729 ? format('%m-%d') : format('%Y-%m-%d');
    const formatTime = format('%I:%M:%S %p');

    const loadPortfolioAndJump = (row) => {
      window.scroll(0, document.querySelector('.portfolio-configuration:not(.out-of-focus)').getBoundingClientRect().top + window.pageYOffset);

      var portfolioToUse = row;

      // Replace a saved run based on a Model Portfolio to use the latest 'model'
      if (portfolioToUse.modelProposalTicker){
        var potentialPort = this.props.modelPortfolios.filter( model => {
          return model.ticker === row.modelProposalTicker;
        }) 

        portfolioToUse = potentialPort.length > 0 ? potentialPort[0] : portfolioToUse;
        portfolioToUse.name = portfolioToUse.modelFamily + ' - ' + portfolioToUse.modelRiskTolerance;

        // Load the portfolio into the entry
        loadPortfolio(portfolioToUse);

        // Store the selected model into the entry side
        setSelectedModel(portfolioToUse, inFocus);

        // Set the model family so the model dropdown is updated
        setSelectedModelFamily(portfolioToUse.modelFamily, inFocus);

        // Show the model input entry
        setShowModelInput(true, inFocus);

        // Set the compare mode
        setCompareMode(inFocus);
        
      } else {
        
        // Load the portfolio into the entry
        loadPortfolio(portfolioToUse);

        // Show the Security input entry
        setShowModelInput(false, inFocus);
      }     
      
    }

    const showImportantInfoModal = Array.isArray(history) && history.length === 0 && !importantInfoAccepted && dpdIsOpen ? true : false;

    // Set up pagination
    let historyToShow = []
    let pageCount = 1
    if (Array.isArray(history) && history.length){
      historyToShow = history.slice(min, max);
      pageCount = Math.ceil(history.length / numPerPage);
    }

    return (
      <div className="history">
        {typeof history === 'string' ? <h2>{history}</h2> : null}
        <h2></h2>
        {!Array.isArray(history) || !history.length
          ? 
            // Modal for Important Information - only shown when there is no run history
            // is clicked and none already exist
            <ImportantInfoModal
                isOpen={showImportantInfoModal}
                onClose={this.handleCloseImportantInfoModal}
            />

          : <div>
              <h2>{TEXT.savedPortfoliosLabel}</h2>
              <table>
                <thead>
                  <tr>
                    <th className="favorite-column" />
                    {/* Show the Portfolio name based on the feature switch */}
                    {featuresEditPortfolioName ? <th>{TEXT.savedPortfoliosNameLabel}</th> : null }
                    <th>{TEXT.savedPortfoliosDateLabel}</th>
                    <th className="hide-sm">{TEXT.savedPortfoliosTimeLabel}</th>
                    <th className="hide-sm">{TEXT.savedPortfoliosObjectiveLabel}</th>
                    <th>{TEXT.savedPortfoliosTickersLabel}</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {historyToShow.map(row => (
                    <tr key={row.id} onClick={() => loadPortfolioAndJump(row)}>
                      <td className="favorite-column">
                        <Favorite
                          value={
                            pendingFavoritePortfolio[row.id]
                              ? !row.favorite
                              : row.favorite
                          }
                          onClick={event => {
                            favoriteSavedPortfolio(row.id, !row.favorite);
                            event.stopPropagation();
                          }}
                        />
                      </td>
                      {featuresEditPortfolioName ? 
                        <td>
                          {!row.name ? '' : row.name.split(' ')
                            .reduce((t,v,i) => {
                              if (i < 2) {
                                return [t[t.length - 1] + ' ' + v];
                              } else if (t[t.length - 1].length < 32){
                                return [...t.slice(0, t.length - 1), t.slice(t.length - 1) + ' ' + v];
                              } else {
                                return [...t, 0, v];
                              }
                            },[''])
                            .map((o,i) => o !== 0 ? <span key={o}>{o}</span> : <br key={i} />)
                          }
                        </td> : null }
                      <td>
                        {row.runDate && formatDate(
                          timeMinute.offset(
                            new Date(row.runDate), 
                            -1*(new Date().getTimezoneOffset())
                          )
                        )}
                      </td>
                      <td className="hide-sm">
                        {row.runDate && formatTime(
                          timeMinute.offset(
                            new Date(row.runDate), 
                            -1*(new Date().getTimezoneOffset())
                          )
                        )}
                      </td>
                      <td className="hide-sm">
                        {(investmentGoalOptions.filter(o => o.value === row.investmentGoal)[0] || {}).label}
                      </td>
                      <td className="ticker">
                        {row.holdings[0].tickers
                          .map(v => <span key={v}>{v}</span>)
                          .reduce((t,v,i) => 
                            [t,', ',(i % 7 === 0 ? <br key={i}/> : ''),v] )}
                      </td>
                      <td className="remove">
                        {pendingDeletePortfolio[row.id]
                          ? <img src={loadingIndicator} alt="Pending" />
                          : <div
                              className="action"
                              onClick={event => {
                                event.stopPropagation();
                                deleteSavedPortfolio(row.id);
                              }}
                            >
                              ✕
                            </div>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className='row-pagination'>
                  {/* Show pagination */}
                  <ReactPaginate
                    previousLabel={<FontAwesomeIcon icon="chevron-left" size="xs" />}
                    nextLabel={<FontAwesomeIcon icon="chevron-right" size="xs" />}
                    pageCount={pageCount}
                    breakLabel={'...'}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    onPageChange={this.paginate}
                    containerClassName={'pagination'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-item'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'pageLink'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'pageLink'}
                    activeClassName={'active'}
                    disabledClassName={'disabled'}
                    breakLinkClassName={'break'}
                  />
                </div>

          </div>}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(History);



// WEBPACK FOOTER //
// ./src/History/index.js